import React, { useState, useEffect } from 'react';

const GlobalHeader = () => {
  const [headerContent, setHeaderContent] = useState('');

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = '/lib/cmmn-v2.css';
    document.head.appendChild(link);

    fetch('/lib/head.txt')
      .then((response) => response.text())
      .then((data) => setHeaderContent(data))
      .catch((error) => console.error('Error fetching header content:', error));
  }, []);

  return (
    <div dangerouslySetInnerHTML={{ __html: headerContent }} />
  );
};

export default GlobalHeader;
